import { calculateProductPriceValue } from './helper';

export const sendAddedToCartKlaviyoEvent = (eml, addedItem, items) => {
	// if (!window.cookiesConsent.marketing) return;

	if (!eml) return;
	var _learnq = window._learnq || [];

	_learnq.push(['identify', { $email: eml }]);

	const { itemNames, products, cartValue } = handleSetProductRelated(items);
	const checkoutUrl = window.location.host + '/checkout-step-2';
	_learnq.push([
		'track',
		'Added to Cart',
		{
			$value: cartValue,
			AddedItemProductName: addedItem.nm,
			AddedItemProductID: addedItem.id,
			AddedItemImageURL: addedItem.img1,
			AddedItemURL: window.location.host + addedItem.eurl,
			AddedItemPrice: addedItem.prc,
			AddedItemQuantity: 1,
			ItemNames: [itemNames],
			CheckoutURL: checkoutUrl,
			Items: products
		}
	]);
};

export const sendViewedProductKlaviyoEvent = (eml, item) => {
	// if (!window.cookiesConsent.marketing) return;

	if (!eml) return;
	var _learnq = window._learnq || [];

	_learnq.push(['identify', { $email: eml }]);

	_learnq.push([
		'track',
		'trackViewedItem',
		{
			ProductName: item.nm,
			ProductID: item.id,
			SKU: item.cd,
			Categories: item.catlst,
			ImageURL: item.img1,
			URL: window.location.host + item.eurl,
			Brand: 'Bodytalk',
			Price: calculateProductPriceValue(item)
		}
	]);
};

export const sendStartedCheckoutKlaviyoEvent = (eml, items) => {
	// if (!window.cookiesConsent.marketing) return;

	if (!eml) return;
	var _learnq = window._learnq || [];

	_learnq.push([
		'identify',
		{
			$email: eml
		}
	]);

	let start = Date.now();

	const { itemNames, categories, products, cartValue } = handleSetProductRelated(items);
	const checkoutUrl = window.location.host + '/checkout-step-2';

	_learnq.push([
		'track',
		'Started Checkout',
		{
			$event_id: start,
			$value: cartValue,
			ItemNames: itemNames,
			Categories: categories,
			CheckoutURL: checkoutUrl,
			customer_properties: {
				$email: eml
			},
			Items: products
		}
	]);
};

export const sendPlacedOrderKlaviyoEvent = (order, orderLines) => {
	// if (!window.cookiesConsent.marketing) return;

	const itemNames = [];
	const products = [];

	orderLines.map(item => {
		itemNames.push(item.pnm);

		let product = {
			ProductID: item.pid,
			ProductName: item.nm,
			Quantity: item.qty ?? 1,
			ItemPrice: item.luamt,
			RowTotal: item.amt,
			ImageURL: item.img1
		};

		products.push(product);
	});

	_learnq.push([
		'track',
		'Placed Order',
		{
			customer_properties: {
				$email: order.eml
			},
			/*	properties: {*/
			$event_id: order.uid,
			$value: order.amt,
			OrderId: order.uid,
			ItemNames: itemNames,
			DiscountCode: order.coupon,
			DiscountValue: order.dsct,
			Items: products,
			BillingAddress: {
				FirstName: order.fnm,
				LastName: order.lnm,
				Company: order.cnm,
				Address1: order.adr1,
				Address2: order.adr2,
				City: order.ct,
				Zip: order.pc,
				Phone: order.mob
			},
			ShippingAddress: {
				FirstName: order.dfnm,
				LastName: order.dlnm,
				Company: order.dcnm,
				Address1: order.dadr1,
				Address2: order.dadr2,
				City: order.dct,
				Zip: order.dpc,
				Phone: order.dmob
			},
			/*		},*/
			time: new Date().toISOString()
		}
	]);
};

const handleSetProductRelated = items => {
	let cartValue = 0;
	const itemNames = [];
	const categories = [];
	const products = [];

	items.map(item => {
		cartValue += (item.quantity ?? 1) * item.product.prc;
		categories.push(item.product.cnm);
		itemNames.push(item.product.nm);

		let product = {
			ProductID: item.pid,
			ProductName: item.product.nm,
			Quantity: item.quantity ?? 1,
			ItemPrice: item.product.prc,
			RowTotal: item.product.prc * (item.quantity ?? 1),
			ProductURL: window.location.host + item.product.eurl,
			ImageURL: item.product.img1,
			ProductCategories: item.product.breadcrumbs.map(category => category.nm)
		};

		products.push(product);
	});

	return { itemNames, categories, products, cartValue };
};
